module.exports = __webpack_public_path__ + "static/media/sidebar-5.53e374d5.jpg";